var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-1"},[_c('label',{staticClass:"font-weight-medium"},[_vm._t("default"),_vm._v("   "),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }